
(function () {
  if (!navigator.geolocation) return;

  const root =
    document.querySelector('.store-locator') ||
    document.querySelector('.store-locator__inner') ||
    document;

  const ownedRegionsContainer = root.querySelector(
    '.store-locator__regions[data-group="wb-owned"]'
  );
  const regionNodes = ownedRegionsContainer
    ? Array.from(
        ownedRegionsContainer.querySelectorAll(
          'details.store-locator__region'
        )
      )
    : [];
  if (!regionNodes.length) return;

  navigator.geolocation.getCurrentPosition(
    (pos) => {
      const userLat = pos.coords.latitude;
      const userLng = pos.coords.longitude;

      let nearestRegion = null;
      let nearestRegionDistance = Infinity;

      regionNodes.forEach((region) => {
        const regionBody =
          region.querySelector('.store-locator__region-content') ||
          region;

        const cityBlocks = Array.from(
          regionBody.querySelectorAll('section.store-locator__city')
        );
        cityBlocks.forEach((cityBlock) => {
          const cityLat = parseFloat(cityBlock.dataset.lat);
          const cityLng = parseFloat(cityBlock.dataset.lng);

          if (Number.isNaN(cityLat) || Number.isNaN(cityLng)) {
            cityBlock.dataset.cityDistance = '';
          } else {
            const cityKm = haversine(userLat, userLng, cityLat, cityLng);
            cityBlock.dataset.cityDistance = String(cityKm);
          }

          const cityStores = Array.from(cityBlock.querySelectorAll('.store-locator__store'));
          if (!cityStores.length) return;

          cityStores.sort((a, b) => {
            const ba = isBoutiqueStore(a);
            const bb = isBoutiqueStore(b);
            if (ba !== bb) return ba ? -1 : 1;

            const oa = parseInt(
              a.dataset.defaultSortOrder || '',
              10
            );
            const ob = parseInt(
              b.dataset.defaultSortOrder || '',
              10
            );

            const aHasOrder = !Number.isNaN(oa);
            const bHasOrder = !Number.isNaN(ob);

            if (aHasOrder && bHasOrder && oa !== ob) return oa - ob;
            if (aHasOrder && !bHasOrder) return -1;
            if (!aHasOrder && bHasOrder) return 1;

            return (a.textContent || '')
              .trim()
              .localeCompare((b.textContent || '').trim());
          });

          const parent =
            cityBlock.querySelector('.store-locator__stores') || cityBlock;
          cityStores.forEach((node) => parent.appendChild(node));
        });

        cityBlocks.sort((a, b) => {
          const da = parseFloat(a.dataset.cityDistance);
          const db = parseFloat(b.dataset.cityDistance);
          const aOk = isFinite(da);
          const bOk = isFinite(db);
          if (!aOk && bOk) return 1;
          if (aOk && !bOk) return -1;
          if (da !== db) return da - db;
          return (a.textContent || '').trim().localeCompare((b.textContent || '').trim());
        });

        cityBlocks.forEach((block) => regionBody.appendChild(block));

        const regionDistance = cityBlocks.reduce((min, block) => {
          const d = parseFloat(block.dataset.cityDistance);
          return Math.min(min, isFinite(d) ? d : Infinity);
        }, Infinity);

        region.dataset.regionDistance = isFinite(regionDistance) ? String(regionDistance) : '';

        if (regionDistance < nearestRegionDistance) {
          nearestRegionDistance = regionDistance;
          nearestRegion = region;
        }
      });

      const regionsContainer = findRegionsContainer(regionNodes);
      const sortedRegions = regionNodes.slice().sort((a, b) => {
        const da = parseFloat(a.dataset.regionDistance);
        const db = parseFloat(b.dataset.regionDistance);
        const aOk = isFinite(da);
        const bOk = isFinite(db);
        if (!aOk && bOk) return 1;
        if (aOk && !bOk) return -1;
        if (da !== db) return da - db;
        return (a.textContent || '').trim().localeCompare((b.textContent || '').trim());
      });

      sortedRegions.forEach((region) => regionsContainer.appendChild(region));

      if (nearestRegion) {
        sortedRegions.forEach((r) => {
          r.open = (r === nearestRegion);
        });
        requestAnimationFrame(() => {
          document.dispatchEvent(new CustomEvent('store-locator:sync-details'));
        });
      }
    },
    () => {
      console.warn('Store locator: location permission denied');
    }
  );

  function findRegionsContainer(regionNodes) {
    const first = regionNodes[0];
    const parent = first && first.parentElement;
    return parent || document.body;
  }

  function isBoutiqueStore(storeEl) {
    const storeType = (storeEl.dataset.storeType || '').trim().toLowerCase();
    if (storeType === 'concession') return false;
    const ownedStoreType = (storeEl.dataset.ownedStoreType || '').trim().toLowerCase();
    if (ownedStoreType === 'boutique') return true;
    if (ownedStoreType === 'non-boutique') return false;
    return false;
  }

  function haversine(lat1, lon1, lat2, lon2) {
    const R = 6371;
    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) *
      Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function toRad(v) {
    return (v * Math.PI) / 180;
  }
})();


(() => {
  function animateStoreLocatorDetails() {
    const detailsList = document.querySelectorAll(
      'details.store-locator__region'
    );

    const syncDetailsState = () => {
      detailsList.forEach((details) => {
        const content =
          details.querySelector('.details-content') ||
          details.querySelector('.store-locator__region-content');
        if (!content) return;

        if (details.open) {
          content.style.height = content.scrollHeight + 'px';
          content.style.opacity = '1';
        } else {
          content.style.height = '0px';
          content.style.opacity = '0';
        }
      });
    };

    syncDetailsState();
    document.addEventListener('store-locator:sync-details', syncDetailsState);

    detailsList.forEach((details) => {
      const summary = details.querySelector('summary');
      const content = details.querySelector('.details-content') ||
        details.querySelector('.store-locator__region-content');

      if (!summary || !content) return;

      summary.addEventListener('click', (e) => {
        e.preventDefault();

        const isOpen = details.open;
        const detailsGroup =
          details.closest('.store-locator__regions') || document;

        detailsGroup
          .querySelectorAll('details.store-locator__region[open]')
          .forEach((openDetails) => {
            if (openDetails !== details) {
              closeDetails(openDetails);
            }
          });

        if (isOpen) {
          closeDetails(details);
        } else {
          openDetails(details);
        }
      });

      function openDetails(el) {
        const body =
          el.querySelector('.details-content') ||
          el.querySelector('.store-locator__region-content');
        if (!body) return;
        el.open = true;

        body.style.height = '0px';
        body.style.opacity = '0';

        requestAnimationFrame(() => {
          body.style.height = body.scrollHeight + 'px';
          body.style.opacity = '1';
        });
      }

      function closeDetails(el) {
        const body =
          el.querySelector('.details-content') ||
          el.querySelector('.store-locator__region-content');
        if (!body) return;
        body.style.height = body.scrollHeight + 'px';

        requestAnimationFrame(() => {
          body.style.height = '0px';
          body.style.opacity = '0';
        });

        body.addEventListener(
          'transitionend',
          () => {
            el.open = false;
          },
          { once: true }
        );
      }
    });
  }

  document.addEventListener('DOMContentLoaded', animateStoreLocatorDetails);
})();
